import React from "react";
import { connect } from "react-redux";
import {
  downloadReport,
  deleteValidation,
  startValidation,
  startReValidation,
} from "../../../Containers/EmailValidation/actions";
import { numberWithCommas } from "../../../utility/commonHelpers";
import momentTimezone from "moment-timezone";
class BulkValidationStats extends React.Component {
  constructor(props) {
    super(props);
    this._handleClick = this._handleClick.bind(this);
  }
  _handleClick(e) {
    const value = e.currentTarget.dataset.key;
    const target = e.target.name;
    const reverify_name = e.currentTarget.dataset.name;
    // console.log("Reverify Event : " + JSON.stringify(e.target.dataset));
    const guid = e.target.dataset.key;
    const selectedIndex = this.props.selectedIndex;
    const selectedFile = this.props.emailstatus;
    // console.log("Selected Index to delete : " + JSON.stringify(this.props));
    const { dispatch } = this.props;
    if (target == "delete") {
      this.props.dispatch(deleteValidation({ guid, selectedIndex }));
    } else if (reverify_name == "goodreverify") {
      this.props.dispatch(
        startReValidation(selectedFile, selectedIndex, "valid")
      );
    } else if (reverify_name == "badreverify") {
      this.props.dispatch(
        startReValidation(selectedFile, selectedIndex, "invalid")
      );
    } else if (reverify_name == "unknownreverify") {
      this.props.dispatch(
        startReValidation(selectedFile, selectedIndex, "unknown")
      );
    } else if (reverify_name == "allreverify") {
      this.props.dispatch(
        startReValidation(selectedFile, selectedIndex, "all")
      );
    } else if(reverify_name == "non_processed_reverify") {
      this.props.dispatch(
        startReValidation(selectedFile, selectedIndex, "NotProcessed")
      );
    } else this.props.dispatch(downloadReport(target, value, momentTimezone.tz.guess()));
  }

  render() {
    const emailStats = this.props;
    // console.log("emailStats:" + JSON.stringify(emailStats));
    return (
      <div className="email-stats">
        {emailStats.emailstatus ? (
          <div className="col-lg-6 col-md-6 col-sm-12 emails-stats-right">
            <div className="emailVerificationTiles">
              <h3 style={{wordBreak:"break-all"}}>{emailStats.emailstatus.fileName}</h3>
              <div className="col-lg-8 col-md-8 col-sm-6 col-xs-8">
                <div className="profile_left">
                  <ul className="list-unstyled user_data">
                    <li>
                      Total Records :
                      <strong>
                        {emailStats.emailstatus.totalEmails} Emails
                      </strong>
                    </li>
                    {/* <li><span>Run Time:</span> 1.7 Min.</li> */}
                    <li className="eMailInlineList">
                      {emailStats.emailstatus.status == "Completed" ? (
                        <span>
                          Credits Consumed :{" "}
                          <strong>
                            {emailStats.emailstatus.good +
                              emailStats.emailstatus.bad +
                              emailStats.emailstatus.unknownScored}
                          </strong>
                        </span>
                      ) : (
                        <span>
                          In Progress :{" "}
                          <strong>
                            {emailStats.emailstatus.totalEmails - emailStats.emailstatus.nonProcessed -
                              (emailStats.emailstatus.good +
                                emailStats.emailstatus.bad +
                                emailStats.emailstatus.unknownScored +
                                emailStats.emailstatus.unknown)}
                          </strong>
                        </span>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 col-xs-4">
                <div className="cardCol3">
                  {emailStats.emailstatus.status_code != -2 ? (
                    <div className="delMenu">
                      <i
                        className="fa fa-cloud-download dropdown-toggle"
                        data-toggle="dropdown"
                      />
                      <ul
                        guid={emailStats.emailstatus.guid}
                        role="menu"
                        className="dropdown-menu dmCUstom pull-right"
                      >
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            value={"valid"}
                            name={"valid"}
                            onClick={this._handleClick}
                          >
                            Valid
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            value={"invalid"}
                            name={"invalid"}
                            onClick={this._handleClick}
                          >
                            Invalid
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            value={"unknown"}
                            name={"unknown"}
                            onClick={this._handleClick}
                          >
                            Unknown
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            value={"NotProcessed"}
                            name={"NotProcessed"}
                            onClick={this._handleClick}
                          >
                            Not Verified
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            value={"full_report"}
                            name={"full_report"}
                            onClick={this._handleClick}
                          >
                            Full Report
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {emailStats.emailstatus.status_code == 1 ||
                  emailStats.emailstatus.status_code == 0 ? (
                    <div className="cardMenu actions">
                      <i
                        className="fa fa-ellipsis-v dropdown-toggle"
                        data-toggle="dropdown"
                      />
                      <ul
                        role="menu"
                        className="dropdown-menu dmCUstom pull-right"
                      >
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            data-name="goodreverify"
                            onClick={this._handleClick}
                          >
                            <i className="fa fa-address-book" /> Reverify Valid
                            Emails
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            data-name="badreverify"
                            onClick={this._handleClick}
                          >
                            <i className="fa fa-address-book" /> Reverify
                            Invalid Emails
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            data-name="unknownreverify"
                            onClick={this._handleClick}
                          >
                            <i className="fa fa-address-book" /> Reverify
                            Unknown Emails
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            data-name="non_processed_reverify"
                            onClick={this._handleClick}
                          >
                            <i className="fa fa-address-book" /> Reverify Non Verified Emails
                          </a>
                        </li>
                        <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            data-name="allreverify"
                            onClick={this._handleClick}
                          >
                            <i className="fa fa-address-book" /> Reverify All
                          </a>
                        </li>
                        {/* <li>
                          <a
                            data-key={emailStats.emailstatus.guid}
                            name={"delete"}
                            value={"delete"}
                            onClick={this._handleClick}
                          >
                            Delete
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="clearfix" />
              </div>
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="cardPadding">
                <div
                  id="collapseOne_reg"
                  className="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingOne_reg"
                  style={{ clear: "both" }}
                >
                  <div className="emailVerTiles">
                    <div className="emailVerify good">
                      <ul>
                        <li className="emailVeriStatus">Valid</li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-green"
                              role="progressbar"
                              data-transitiongoal={50}
                              style={{
                                width:
                                  (emailStats.emailstatus.good /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="70"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {emailStats.emailstatus.good}
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    <div className="emailVerify bad">
                      <ul>
                        <li className="emailVeriStatus">Invalid</li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-red"
                              role="progressbar"
                              data-transitiongoal="10"
                              style={{
                                width:
                                  (emailStats.emailstatus.bad /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="10"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {emailStats.emailstatus.bad}
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    <div className="emailVerify unknown">
                      <ul>
                        <li className="emailVeriStatus">Unknown scored</li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-darkUnknownScored"
                              role="progressbar"
                              data-transitiongoal="16"
                              style={{
                                width:
                                  (emailStats.emailstatus.unknownScored /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="16"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {numberWithCommas(
                            emailStats.emailstatus.unknownScored
                          )}{" "}
                          <small style={{ color: "#999" }} />
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    <div className="emailVerify unknown">
                      <ul>
                        <li className="emailVeriStatus">Unknown</li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-purple"
                              role="progressbar"
                              data-transitiongoal="16"
                              style={{
                                width:
                                  (emailStats.emailstatus.unknown /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="16"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {emailStats.emailstatus.unknown}{" "}
                          <small style={{ color: "#999" }}>(No charges)</small>
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    <div className="emailVerify syntax-error">
                      <ul>
                        <li className="emailVeriStatus">
                          Invalid email format
                        </li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar  bg-light-green"
                              role="progressbar"
                              data-transitiongoal="16"
                              style={{
                                width:
                                  (emailStats.emailstatus.syntaxError /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="16"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {emailStats.emailstatus.syntaxError}{" "}
                          <small style={{ color: "#999" }}>(No charges)</small>
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    <div className="emailVerify duplicate">
                      <ul>
                        <li className="emailVeriStatus">Duplicates</li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-blue"
                              role="progressbar"
                              data-transitiongoal="16"
                              style={{
                                width:
                                  (emailStats.emailstatus.duplicate /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="16"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {emailStats.emailstatus.duplicate}{" "}
                          <small style={{ color: "#999" }}>(No charges)</small>
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    <div className="emailVerify duplicate">
                      <ul>
                        <li className="emailVeriStatus">Not Verified</li>
                        <li className="emailVeriProgress">
                          <div
                            className="progress progress_sm"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-soft-orange"
                              role="progressbar"
                              data-transitiongoal="16"
                              style={{
                                width:
                                  (emailStats.emailstatus.nonProcessed /
                                    emailStats.emailstatus.totalEmails) *
                                    100 +
                                  "%",
                              }}
                              aria-valuenow="16"
                            />
                          </div>
                        </li>
                        <li className="emailVeriCount">
                          {emailStats.emailstatus.nonProcessed}{" "}
                          <small style={{ color: "#999" }}>(No charges)</small>
                        </li>
                      </ul>
                      <div className="clearfix" />
                    </div>
                    {/* <div class="emailVerify unknown">
                                    <ul>
                                        <li class="emailVeriStatus">Syntax error</li>
                                        <li class="emailVeriProgress">
                                            <div class="progress progress_sm" style={{width: "100%"}}>
                                                <div class="progress-bar bg-orange" role="progressbar" data-transitiongoal="04" style={{width: "4%"}} aria-valuenow="4"></div>
                                            </div>
                                        </li>
                                        <li class="emailVeriCount">3,108 <small style={{color:"#999"}}>(No charges)</small></li>
                                    </ul>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="emailVerify unknown">
                                    <ul>
                                        <li class="emailVeriStatus">Duplicate</li>
                                        <li class="emailVeriProgress">
                                            <div class="progress progress_sm" style={{width: "100%"}}>
                                                <div class="progress-bar bg-blue-sky" role="progressbar" data-transitiongoal="06" style={{width: "6%"}} aria-valuenow="6"></div>
                                            </div>
                                        </li>
                                        <li class="emailVeriCount">2,072 <small style={{color:"#999"}}>(No charges)</small></li>
                                    </ul>
                                    <div class="clearfix"></div>
                                </div> */}
                    <div className="clearfix" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default connect()(BulkValidationStats);



// WEBPACK FOOTER //
// ./src/components/EmailVerification/VerificationJobsList/BulkValidationStats.js